module.exports = __webpack_public_path__ + "static/media/atar-choosing-hsc-subjects.eb88ef12.jpg";